import { Alert, Button, Group, Stack, Text } from '@mantine/core';

function formatWhen(iso) {
  if (!iso) return '';
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return '';
  return new Date(ts).toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  }).toLowerCase();
}

export default function OrganicSyncBanner({ syncState, onRunNow, running = false }) {
  const state = syncState || {};
  if (!state.syncing && state.lastRunOk !== false) return null;
  const total = Number.isFinite(Number(state.totalConnections)) ? Number(state.totalConnections) : null;
  const when = formatWhen(state.lastRunAt);

  return (
    <Alert color={state.syncing ? 'sage' : 'red'} variant="light" radius="md">
      <Stack gap={4}>
        <Text size="sm" fw={600}>
          {state.syncing ? 'Syncing your LinkedIn network...' : 'LinkedIn sync failed'}
        </Text>
        <Text size="xs" style={{ color: 'var(--aviary-muted)' }}>
          {state.syncing
            ? 'Backfill is running in the background. You can keep using Aviary.'
            : (state.lastError || 'Backfill did not complete.')}
          {total != null ? ` Last connection count: ${total}.` : ''}
          {when ? ` Updated ${when}.` : ''}
        </Text>
        {!state.syncing && (
          <Group justify="flex-start">
            <Button size="xs" color="sage" variant="light" onClick={onRunNow} loading={running}>
              Run backfill again
            </Button>
          </Group>
        )}
      </Stack>
    </Alert>
  );
}
